package one.healthium.profile.ui.avatar

import androidx.compose.runtime.Immutable
import one.healthium.domain.user.UserModel

@Immutable
internal data class UserAvatarUiState(
    val loading: Boolean = false,
    val userModel: UserModel? = null,
) {
    val userAvatarUrl: String? = userModel?.profile?.avatarUrl
}
